module.exports = __webpack_public_path__ + "static/media/img4.2d046e62.jpg";